import Header from '../Header/Header';
import Footer from '../Footer';
import Blog from '../Blog/Blog'

  const pathData = [
    { path: '/', title: 'Home' },
    { path: '/blog', title: 'Blog' }
  ];

const BlogPage = () => {
  return (
    <>
      <Header logoColor="dark" />
      <main>
        <Blog pathData={pathData}/>
      </main>

      <Footer />
    </>
  );
};

export default BlogPage;
